import { useEffect, useState } from 'react';
import { laboratoryClient } from './laboratoryClient';
import { VALUE_PROP_MODAL_CONFIGS } from '../ums/ValuePropModal/constants';

export const UPG_6101_TREATMENT_KEY = 'upg-6101';

export const useUPG6101Experiment = (upgradeKey: string) => {
  const isExperimentKey = upgradeKey in VALUE_PROP_MODAL_CONFIGS;
  const [isUPG6101Variation, setIsUPG6101Variation] = useState<boolean>(false);
  const [isUPG6101Fetched, setIsUPG6101Fetched] = useState<boolean>(
    !isExperimentKey
  );

  useEffect(() => {
    if (!isUPG6101Fetched) {
      laboratoryClient.resolve((treatments) => {
        if (Object.keys(treatments)?.length) {
          const treatment = treatments[UPG_6101_TREATMENT_KEY];
          if (treatment?.parameters?.group) {
            setIsUPG6101Variation(treatment.parameters.group === 'variation');
          }
        }
        setIsUPG6101Fetched(true);
      });
    }
  }, [isUPG6101Fetched]);

  return {
    isUPG6101Variation,
    isUPG6101Fetched,
  };
};
